(function ($) {
    $(document).ready(function () {
        $('.emp-slider .slide-wrap .content-wrap').matchHeight();
        // $('body .emp-slider .slide-wrap .content-wrap').addClass('wow fadeInUp');
        // $('body .emp-slider .slide-wrap .slick-next').addClass('wow fadeInUp');
        $('body .emp-slider ').addClass('wow fadeInUp');
        $("body .emp-slider .slide-wrap .content-wrap").click(function (event) {
            event.stopPropagation();
            var ind = $(this).index();
            $("body .overlay-emp").addClass('active');
            $('.overlay-emp .slick-dots li:eq('+ind+')').trigger('click');
            if ($("body .overlay-emp").hasClass('active')) {
                $("body").addClass('overflow');
            }
            $("body .emp-slider").addClass('show-overlay');

        });
        $("body .overlay-emp").find(".close-btn").click(function (e) {
            e.preventDefault();
            $("body .overlay-emp").removeClass('active');
            $("body").removeClass('overflow');
          $("body .emp-slider").removeClass('show-overlay');
            $('body .emp-slider .slide-wrap .content-wrap.slick-active').removeClass('prev-active');
            classAdd();
            // $('body .emp-slider .slide-wrap .content-wrap.slick-slide').classAdd();
        });
        $('body .overlay-emp .slide-overlay').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            adaptiveHeight: false,
            speed: 1000,
            dots: true,
            prevArrow: ".overlay-emp .prev",
            nextArrow: ".overlay-emp .next",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        speed: 0,
                        centerMode: true,
                        slidesToShow: 1
                    }
                }
            ]
        });
        $('body .emp-slider .slide-wrap').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrow: true,
            focusOnSelect: false,
            speed: 400,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        // centerPadding: '40px',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        // centerPadding: '40px',
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        // centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        });
        $('body .emp-slider .slide-wrap .slick-prev').click(function () {
            classAdd();
            // $('body .emp-slider .slide-wrap .content-wrap.slick-slide').addClass(addClass());
        });
        $('body .emp-slider .slide-wrap .slick-next').click(function () {
            classAdd();
        });
        $('body .emp-slider .slide-wrap .content-wrap.slick-slide').click(function () {
            classAdd();
        });

        $(".overlay-emp  .col-three").on("click",function () {
            var tabType= $(this).attr("data-attr");
            var tabIndex = $(this).index();
            $(this).parents(".overlay-content").find(".extra-content-overlay .tab-container").each(function () {
                var $tabType = $(this).attr("data-attr");
                if(tabType === $tabType){
                    $(".overlay-emp .extra-content-overlay").show();
                    if( $(".overlay-emp .extra-content-overlay .tab-container").hasClass('active')){
                        $(".overlay-emp .extra-content-overlay .tab-container").removeClass('active');
                    }
                    $(this).addClass("active");
                    $('.overlay-emp .slide-overlay').slick("slickSetOption", "swipe", false);
                    $(".overlay-emp .extra-content-overlay").css("opacity",'1');
                    $(".overlay-emp .next").hide();
                    $(".overlay-emp .prev").hide();
                    $(".overlay-emp .slide-overlay .overlay-content .close-btn").hide();
                }
            });
        });
        $(".overlay-emp .extra-content-overlay .back-btn").on("click",function () {
            $(".overlay-emp .extra-content-overlay .tab-container").removeClass('active');
            $(".overlay-emp .extra-content-overlay").css("opacity",'0');
            setTimeout(function () {
                $('.overlay-emp .slide-overlay').slick("slickSetOption", "swipe", true);
                $(".overlay-emp .extra-content-overlay").hide();
                $(".overlay-emp .next").show();
                $(".overlay-emp .prev").show();
                $("body .overlay-emp .slide-overlay .overlay-content .close-btn").show();
            }, 400);
        });

    });
    $(window).on("load resize", function () {
        var window_width = $(window).width();

        if (window_width <= 992) {
            var window_height = $(window).height();
            var content_height = window_height - 300;
            $("body .overlay-emp .slide-overlay .overlay-content .content-box").css(
                {
                    'max-height': content_height,
                    'overflow': 'auto',
                }
            );
        }
        if ($("body .overlay-emp").hasClass('active')) {
            $("body").addClass('overflow');
        }
        setTimeout(function () {
            classAdd();
        }, 100);
    });
    $(window).on("load", function () {
        $(".overlay-emp").removeClass("hide");
    });


    function classAdd() {
        var index = $('body .emp-slider .slide-wrap .content-wrap.slick-slide.slick-current').index();
        var slickLength = $('body .emp-slider .slide-wrap .content-wrap.slick-slide.slick-active').length;
        var index = $('body .emp-slider .slide-wrap .content-wrap.slick-slide.slick-current').index();
        var slickLength = $('body .emp-slider .slide-wrap .content-wrap.slick-slide').length;
        var slickSlide = $('body .emp-slider .slide-wrap .content-wrap.slick-slide').length - $('body .emp-slider .slide-wrap .content-wrap.slick-cloned').length;

    }
})(jQuery);